import React, { useState } from 'react';
import classNames from 'classnames';
import Cookies from 'js-cookie';

import LinkButton from '@components/libraryV2/LinkButton';

import * as styles from './styles.module.scss';

const ROOT_DOMAIN = process.env.ROOT_DOMAIN; // eslint-disable-line prefer-destructuring

const EnrollmentBanner = () => {
  const [isClosed, setIsClosed] = useState(false);
  const enrollmentOrgName = Cookies.get('enrollmentOrgName');
  const enrollmentUrl = Cookies.get('enrollmentUrl');

  const onClick = () => {
    setIsClosed(true);
    Cookies.remove('enrollmentOrgName', { domain: ROOT_DOMAIN });
    Cookies.remove('enrollmentUrl', { domain: ROOT_DOMAIN });
  };

  if (isClosed || !enrollmentOrgName || !enrollmentUrl) return null;

  return (
    <div className={styles.layout}>
      <i className={classNames(styles.empty, 'fa-fw')} />
      <div className={styles.content}>
        <div className={styles.text}>
          Looking for the <b>{enrollmentOrgName}</b> enrollment page?
        </div>
        <LinkButton
          className={styles.button}
          href={enrollmentUrl}
          size="mouse"
          target="_blank"
          rel="noopener noreferrer"
        >
          Enroll now
        </LinkButton>
      </div>
      <i
        className={classNames(styles.closeIcon, 'fa-solid fa-xmark')}
        onClick={onClick}
      />
    </div>
  );
};

export default EnrollmentBanner;
